import {
  doc,
  getDoc,
  setDoc,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { db } from "../config/FirebaseConfig.js"; // Import the Firebase setup
import Icon1 from "../icons/Icon.js";
import { useState } from "react";

import SmallSpinner from "../loading/SmallSpinner.js";
import moment from "moment";
import { formatToCentimes } from "../admin/AdminDashboard.js";

import { formatCentime } from "../modals/SignMarket.js";
import { fi, hi } from "date-fns/locale";
import dayjs from "dayjs";
import SecondaryButton from "../buttons/SecondaryButton.js";
import { getPartnerTypeName } from "../pages/Partner.js";
import { checkDB, getFlutterTime, getOrgDataById } from "./DataFunctions.js";
import { hasInfiltro } from "../hexagone/VisibilityHelpers.js";
import { audit_steps_titles } from "../folder_modals/TimelineFolderAudit.js";
import { getBridgeRejectionStatusExplanation } from "../folder_modals/ReglementFolder.js";
import Tippy from "@tippyjs/react";

// Save organization data to Firestore
export async function saveOrg(orgData) {
  const docRef = doc(db, "org", orgData.id);
  await setDoc(docRef, orgData); // Save the plain object directly
}

// Get organization by ID
export async function getOrgById(id) {
  return getOrgDataById(id);
}

export async function getOrgByRef(docRef) {
  const docSnapshot = await getDoc(checkDB(docRef));
  if (docSnapshot.exists()) {
    return { id: docRef.id, ref: docRef, ...docSnapshot.data() }; // Return plain object with document reference and ID
  }
  console.warn("no doc");
  return null; // Return null if no document exists
}

export async function getInvoicesByOrgRef(org_id, type) {
  let foldersQuery = [];
  if (type === "master") {
    foldersQuery = query(
      collection(db, "devis"),
      where("org_id", "==", org_id)
    );
  } else if (type === "client") {
    foldersQuery = query(
      collection(db, "devis"),
      where("client_id", "==", org_id)
    );
  }

  // Fetch the documents that match the query
  const querySnapshot = await getDocs(foldersQuery);

  // Map the documents to an array of folder data with document ID and reference
  const folders = querySnapshot.docs.map((doc) => ({
    id: doc.id,
    ref: doc.ref,
    ...doc.data(),
  }));

  return folders;
}

// Transform clients into a DataGrid-friendly format
export function transformClientsToTable(
  clientss,
  client_alerts = [],
  tab = "constructor"
) {
  // Define columns for DataGrid, customize based on your data structure

  let clients = [...clientss];
  if (tab === "constructor") {
    // only constructor
    clients = clients.filter((client) => client.client_type === "constructor");
  } else if (tab === "architect") {
    // only architect
    clients = clients.filter((client) => client.client_type === "architect");
  }

  const columns = [
    { field: "id", headerName: "ID", width: 200 },

    {
      field: "name",
      headerName: "Nom",
      flex: 1,

      renderCell: (params) => {
        let client_type = params.row.client_type;
        let row_id = params.id;
        let color_style = client_alerts.includes(row_id)
          ? "text-red-500 bg-red-100 mt-2"
          : client_type === "constructor"
            ? "text-indigo-500 bg-indigo-50"
            : params.value === "Particulier"
              ? "text-purple-500 bg-purple-50"
              : "text-blue-400  bg-blue-50";
        return (
          <div className="flex flex-row items-center">
            <div>
              <div
                className={`inline-flex h-6 items-center rounded-full px-2 py-1 flex-row ${color_style} font-light gap-1`}
              >
                {client_alerts.includes(row_id) && (
                  <span className="flex items-center justify-center ">
                    <Icon1 icon_name="warning" size={18} fill="red" />
                  </span>
                )}
                <span className="whitespace-nowrap">{params.value}</span>
              </div>
            </div>
          </div>
        );
      },
    },
    { field: "email", headerName: "Email", flex: 2 },

    { field: "ville", headerName: "Ville", flex: 1 },
    {
      field: "date",
      headerName: "Création",
      flex: 1,
      renderCell: (params) => {
        const date = params.value;
        return (
          <div className="flex flex-row items-center">
            {date && new Date(date.seconds * 1000).toLocaleString()}
          </div>
        );
      },
    },

    // Add more columns as needed
  ];

  // Create rows from the clients array
  let rows = clients.map((client, index) => ({
    id: client.id || index + 1, // Use client's ID or default index
    ref: client.ref || null, // Include client's document reference
    name: client.name || "",
    email: client.email || "",
    date: client.creation_date, // Use client's creation date or default
    client_type: client.client_type || "", // Use client's type or default
    ville: client.infos?.ville || "", // Use client's city or default
  }));

  rows = rows.sort((a, b) => {
    return a.name.trim().localeCompare(b.name.trim());
  });

  return { rows, columns }; // Return rows and columns for the DataGrid
}

// Transform clients into a DataGrid-friendly format
export function transformPartnersToTable(
  partnerss,
  all_workspaces,
  tab = "constructor"
) {
  // Define columns for DataGrid, customize based on your data structure

  let partners = [...partnerss];
  if (tab === "all") {
    // only constructor
  } else {
    // only architect
    partners = partners.filter((partner) => partner.partner_type === tab);
  }

  const columns = [
    { field: "id", headerName: "ID", width: 200 },

    {
      field: "name",
      headerName: "Nom",
      flex: 1,

      renderCell: (params) => {
        let partner_type = params.row.partner_type;
        let row_id = params.id;

        return (
          <div className="flex flex-row items-center">
            <div>
              <div
                className={`inline-flex h-6 items-center rounded-lg px-2 py-1 flex-row
                  ${params.row.payment_allowed === false ? "text-indigo-500 bg-indigo-50" : "text-blue-500 bg-blue-50"}
                   border  font-light gap-1`}
              >
                <span className="whitespace-nowrap">{params.value}</span>
              </div>
            </div>
          </div>
        );
      },
    },
    { field: "email", headerName: "Email", flex: 2 },

    { field: "ville", headerName: "Ville", flex: 1 },
    {
      field: "date",
      headerName: "Création",
      flex: 1,
      renderCell: (params) => {
        const date = params.value;
        return (
          <div className="flex flex-row items-center">
            {date && new Date(date.seconds * 1000).toLocaleString()}
          </div>
        );
      },
    },

    // Add more columns as needed
  ];

  // Create rows from the clients array
  let rows = partners.map((client, index) => ({
    id: client.id || index + 1, // Use client's ID or default index
    ref: client.ref || null, // Include client's document reference
    name:
      (client.name || "") +
      " " +
      (all_workspaces.find((workspace) => workspace.partner_id === client.id)
        ?.emoji || ""),
    email: client.email || "",
    date: client.creation_date, // Use client's creation date or default
    client_type: client.client_type || "", // Use client's type or default
    ville: client.infos?.ville || "", // Use client's city or default
    partner_type: client.partner_type || "", // Use client's type or default
    payment_allowed:
      all_workspaces.find((workspace) => workspace.partner_id === client.id)
        ?.permissions?.payment_allowed === true
        ? true
        : false,
  }));

  rows = rows.sort((a, b) => {
    return a.name.trim().localeCompare(b.name.trim());
  });

  return { rows, columns }; // Return rows and columns for the DataGrid
}

// Transform clients into a DataGrid-friendly format
export function transformMastersToTable(
  masters,
  workspaceData,
  handleSwitchWorkspace,
  workspaces = []
) {
  // Define columns for DataGrid, customize based on your data structure
  const columns = [
    { field: "id", headerName: "ID", flex: 1 },

    {
      field: "name",
      headerName: "Nom",
      width: 150,

      renderCell: (params) => {
        let row_id = params.id;

        return (
          <div className="flex flex-row items-center">
            <div>
              <div
                className={`inline-flex h-6 items-center rounded-full px-2 py-1 flex-row font-light gap-1`}
              >
                <span className="whitespace-nowrap">{params.value}</span>
              </div>
            </div>
          </div>
        );
      },
    },
    { field: "email", headerName: "Email", width: 150 },
    { field: "phone", headerName: "Téléphone", width: 100 },

    { field: "ville", headerName: "Ville", width: 100 },
    {
      field: "date",
      headerName: "Création",
      width: 150,
      renderCell: (params) => {
        const date = params.value;
        return (
          <div className="flex flex-row items-center">
            {date && new Date(date.seconds * 1000).toLocaleString()}
          </div>
        );
      },
    },
    {
      field: "action",
      headerName: "Changer",
      width: 150,
      renderCell: (params) => {
        const state = params.value;
        return (
          <div className="flex flex-row items-center h-full  ">
            {state === "current" ? (
              <div className="  text-teal-500 bg-teal-50 px-2 text-h3  w-fit gap-3  flex rounded-full h-6 items-center">
                <Icon1 icon_name="workspace" fill={"#14b8a6"} size={20}></Icon1>
                Espace actuel
              </div>
            ) : (
              <SecondaryButton
                className="w-fit"
                onClick={(e) => {
                  handleSwitchWorkspace(state);
                }}
              >
                Changer d'espace
              </SecondaryButton>
            )}
          </div>
        );
      },
    },

    // Add more columns as needed
  ];

  // Create rows from the clients array
  const rows = masters.map((master, index) => ({
    id: master.id || index + 1, // Use client's ID or default index
    ref: master.ref || null, // Include client's document reference

    name: master.name || "",
    email: master.infos?.email || "",
    phone: master.infos?.phone || "",
    date: master.creation_date, // Use client's creation date or default
    ville: master.infos?.ville || "", // Use client's city or default
    action:
      workspaceData.master_id === master.id
        ? "current"
        : workspaces.find((workspace) => workspace.master_id === master.id)?.id, // Use client's type or default
  }));

  return { rows, columns }; // Return rows and columns for the DataGrid
}
// Transform clients into a DataGrid-friendly format
export function transformOrgsToTable(orgs, filter_type = null) {
  // Define columns for DataGrid, customize based on your data structure

  if (filter_type) {
    orgs = orgs.filter((org) => org.type === filter_type);
  }
  const columns = [
    { field: "id", headerName: "ID", width: 300 },
    { field: "email", headerName: "Email", width: 250 },
    { field: "name", headerName: "Nom", width: 200 },
    { field: "type", headerName: "Type", width: 100 },
    {
      field: "creation",
      headerName: "creation",
      width: 100,
      renderCell: (params) => {
        const creation_date = params.value;
        return (
          <div className="flex flex-row items-center h-full  ">
            {creation_date && new Date(creation_date * 1000).toLocaleString()}
          </div>
        );
      },
    },
    {
      field: "ref",
      headerName: "Ref",
      width: 200,
      renderCell: (params) => {
        const ref = params.value;
        return (
          <div className="flex flex-row items-center h-full  ">
            {ref && ref.id}
          </div>
        );
      },
    },
    {
      field: "fake",
      headerName: "fake",
      width: 80,

      renderCell: (params) => {
        const fake = params.value;
        return (
          <div className="flex flex-row items-center h-full  ">
            {fake ? (
              <div className="  text-shadow_50 bg-orange-100 text-orange-400 px-2 text-h2  w-fit  flex rounded-full h-7 items-center ">
                fake
              </div>
            ) : (
              <div className="  text-shadow_50 bg-green-100 text-green-400 px-2 text-h2  w-fit  flex rounded-full h-7 items-center ">
                real
              </div>
            )}
          </div>
        );
      },
    },
    {
      field: "ltv",
      headerName: "ltv",
      width: 70,

      renderCell: (params) => {
        const ltv = params.value;
        if (ltv === "") {
          return <></>;
        }
        return (
          <div className="flex flex-row items-center h-full  ">
            <div className="  text-shadow_50 bg-green-100 text-green-400 px-2 text-h2  w-fit  flex rounded-full h-7 items-center ">
              {ltv}
            </div>
          </div>
        );
      },
    },
    {
      field: "plan",
      headerName: "plan",
      width: 150,

      renderCell: (params) => {
        const org_plan = params.value;
        const facturation = params.row.facturation;
        let orgData = params.row;
        let trial_days_left = Math.floor(
          (new Date(
            params.row.creation + (facturation.trial_period || 30) * 24 * 3600
          ) -
            getFlutterTime().seconds) /
            60 /
            60 /
            24
        ).toFixed(0);

        if (params.row.type !== "master") {
          return (
            <div className="  text-shadow_50 bg-blue-100 text-blue-400 px-2 text-h2  w-fit  flex rounded-full h-7 items-center">
              partner
            </div>
          );
        }
        return (
          <div className="flex flex-row items-center h-full  ">
            {" "}
            {org_plan === "starter" && (
              <div className="  text-shadow_50 bg-blue-100 text-blue-400 px-2 text-h2  w-fit  flex rounded-full h-7 items-center">
                starter
              </div>
            )}
            {org_plan === "business" && (
              <div className="  text-shadow_50 bg-blue-100 text-blue-400 px-2 text-h2 w-fit  flex rounded-full h-7 items-center">
                business
              </div>
            )}
            {org_plan === "premium" && (
              <div className="  text-shadow_50 bg-purple-100 text-violet-400 px-2 text-h2 w-fit  flex rounded-full h-7 items-center ">
                premium
              </div>
            )}
            {!["starter", "business", "premium"].includes(org_plan) &&
              (facturation?.in_trial ? (
                <div className="  text-shadow_50 bg-orange-100 text-orange-400 px-2 text-h2  w-fit  flex rounded-full h-7 items-center ">
                  trial {trial_days_left} jours
                </div>
              ) : (
                <div className="  text-shadow_50 bg-red-100 text-red-400 px-2 text-h2  w-fit  flex rounded-full h-7 items-center ">
                  trial_ended
                </div>
              ))}
          </div>
        );
      },
    },
    { field: "engagement", headerName: "engagement", width: 100 },

    { field: "ville", headerName: "Ville", width: 150 },
    { field: "users", headerName: "users", width: 70 },
    { field: "workspaces_nbr", headerName: "wo_nbr", width: 70 },
  ];

  // Create rows from the clients array
  const rows = orgs.map((org, index) => ({
    id: org.id || index + 1, // Use client's ID or default index
    ref: org.ref || null, // Include client's document reference
    name: org.name || "", // Use client's name or default 'Unknown'
    email: org.email || "", // Use client's name or default 'Unknown'
    plan: org.facturation?.plan || "", // Use client's name or default 'Unknown'
    engagement: org.facturation?.engagement || "", // Use client's name or default 'Unknown'
    ltv: org.facturation?.LTV || "", // Use client's name or default 'Unknown'
    type: org.type || "", // Use client's type or default
    ville: org.ville || "", // Use client's city or default
    users: org.users_id?.length || 0, // Use client's city or default
    creation: org.creation_date?.seconds,
    facturation: org.facturation,
    fake: org.facturation?.fake_account || false,
    workspaces_nbr: org.workspaces?.length || 0, // Use client's city or default
  }));

  return { rows, columns }; // Return rows and columns for the DataGrid
}

// Transform clients into a DataGrid-friendly format
export function transformInvitesToTable(orgs, SendAgain) {
  // Define columns for DataGrid, customize based on your data structure
  const columns = [
    { field: "id", headerName: "ID", width: 300 },
    { field: "name", headerName: "Nom", width: 200 },

    { field: "email", headerName: "Email", width: 300 },

    {
      field: "type",
      headerName: "Type",
      width: 150,
      renderCell: (params) => {
        const org_type = params.value;
        return (
          <div className="flex flex-row items-center h-full  ">
            <div className="  text-indigo-500 bg-indigo-50 px-2 text-h3 w-fit  flex rounded-lg border-1 h-6 items-center">
              {getPartnerTypeName(org_type)}
            </div>
          </div>
        );
      },
    },
    {
      field: "date",
      headerName: "Date",
      width: 150,
      renderCell: (params) => {
        const invite_date = params.value;
        return (
          <div className="flex flex-row items-center h-full  ">
            {invite_date &&
              new Date(invite_date.seconds * 1000).toLocaleString()}
          </div>
        );
      },
    },
    {
      field: "invite",
      headerName: "Invitation",
      width: 150,
      renderCell: (params) => {
        const status = params.value;
        return (
          <div className="flex flex-row items-center h-full  ">
            {status === "accepted" && (
              <div className="  text-white bg-green-300 px-2 text-h3  w-fit  flex rounded-full h-6 items-center">
                acceptée
              </div>
            )}
            {status === "sent" && (
              <div className="  text-white bg-orange-300 px-2 text-h3 w-fit  flex rounded-full h-6 items-center ">
                en attente
              </div>
            )}
            {status === undefined && (
              <div className="  text-white bg-neutral-300 px-2 text-h3  w-fit  flex rounded-full h-6 items-center ">
                non envoyée
              </div>
            )}
          </div>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 150,
      renderCell: (params) => {
        const status = params.value;
        return (
          <div className="flex flex-row items-center h-full  ">
            <SecondaryButton
              className="w-fit"
              onClick={(e) => {
                SendAgain(e, params.row.ref);
              }}
            >
              Renvoyer
            </SecondaryButton>
          </div>
        );
      },
    },
    // Add more columns as needed
  ];

  // Create rows from the clients array
  const rows = orgs.map((org, index) => ({
    id: org.id || index + 1, // Use client's ID or default index
    ref: org.ref || null, // Include client's document reference
    name: org.name || "", // Use client's name or default 'Unknown'
    email: org.email || "", // Use client's name or default 'Unknown'

    type: org.partner_type || "", // Use client's type or default
    date: org.invite_date, // Use client's city or default
    invite: org.invite, // Use client's city or default
  }));

  return { rows, columns }; // Return rows and columns for the DataGrid
}

// Transform clients into a DataGrid-friendly format
export function transformRemindersToTable(
  jobs,
  CancelReminder,
  navigateWorkspace
) {
  // Define columns for DataGrid, customize based on your data structure
  const columns = [
    { field: "id", headerName: "ID", flex: 1 },
    { field: "nom", headerName: "Nom", width: 150 },

    { field: "emails", headerName: "Email/Téléphone", width: 150 },

    {
      field: "type",
      headerName: "Type",
      width: 150,
      renderCell: (params) => {
        const type = params.value;
        return (
          <div className="flex flex-row items-center h-full  ">
            {type === "sms" && (
              <div className="    text-h3  w-fit  flex rounded-full h-6 items-center">
                Visite (SMS)
              </div>
            )}
            {type === "xml" && (
              <div className="    text-h3  w-fit  flex rounded-full h-6 items-center ">
                Xml (email)
              </div>
            )}
            {type === "payment" && (
              <div className="    text-h3  w-fit  flex rounded-full h-6 items-center ">
                Paiement (email)
              </div>
            )}
          </div>
        );
      },
    },
    {
      field: "date",
      headerName: "Echéance",
      width: 120,
      renderCell: (params) => {
        const invite_date = dayjs.unix(params.value).format("DD/MM/YYYY");
        return (
          <div className="flex flex-row items-center h-full  ">
            {invite_date}
          </div>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      width: 130,
      renderCell: (params) => {
        const status = params.value;
        const completed = params.row.completed;
        const type = params.row.type;
        const counter = params.row.counter;
        const date = params.row.date;

        return (
          <div className="flex flex-row items-center h-full  ">
            {(type === "xml" || type === "payment") &&
              status === "pending" &&
              !completed &&
              counter > 0 && (
                <div className="  text-white bg-orange-400 px-2 text-h2 w-fit  flex rounded-full h-5 items-center">
                  Relancé {counter} fois
                </div>
              )}
            {status === "pending" &&
              !counter &&
              !completed &&
              (date > getFlutterTime().seconds ? (
                <div className="  text-white bg-orange-300 px-2 text-h2 w-fit  flex rounded-full h-5 items-center">
                  Programmé
                </div>
              ) : (
                <div className="  text-white bg-neutral-200 px-2 text-h2 w-fit  flex rounded-full h-5 items-center">
                  Invalide
                </div>
              ))}
            {type === "payment" && completed && status === "completed" && (
              <div className="  text-white bg-green-300 px-2 text-h3  w-fit  flex rounded-full h-5 items-center ">
                Payé
              </div>
            )}
            {status === "sent" && (
              <div className="  text-white bg-green-300 px-2 text-h3  w-fit  flex rounded-full h-5 items-center ">
                Sms reçu
              </div>
            )}
            {type === "xml" && status === "completed" && (
              <div className="  text-white bg-green-300 px-2 text-h3  w-fit  flex rounded-full h-5 items-center ">
                Xml déposé
              </div>
            )}
            {status === "expired" && completed && (
              <div className="  text-white bg-red-300 px-2 text-h3  w-fit  flex rounded-full h-5 items-center ">
                Expiré
              </div>
            )}
          </div>
        );
      },
    },

    {
      field: "action",
      headerName: "Action",
      width: 150,
      renderCell: (params) => {
        const status = params.value;
        return (
          <div className="flex flex-row gap-2 items-center h-full  ">
            <SecondaryButton
              className="w-fit"
              onClick={(e) => {
                navigateWorkspace("/folder/" + params.row.folder_ref.id);
              }}
            >
              <Icon1 icon_name="folder" size={18} fill="grey"></Icon1>
            </SecondaryButton>
            <SecondaryButton
              className="w-fit"
              onClick={(e) => {
                CancelReminder(e, params.row.ref);
              }}
            >
              Supprimer
            </SecondaryButton>
          </div>
        );
      },
    },
    // Add more columns as needed
  ];

  // Create rows from the clients array
  const rows = jobs.map((job, index) => ({
    id: job.id || index + 1, // Use client's ID or default index
    ref: job.ref || null, // Include client's document reference
    nom: job.nom || "", // Use client's name or default 'Unknown'
    emails: job.emails?.length > 0 ? job.emails[0] : job.to, // Use client's name or default 'Unknown'
    status: job.status || "", // Use client's name or default 'Unknown'
    type: job.type || "", // Use client's type or default
    date: job.trigger_date?.seconds || 0, // Use client's city or default
    counter: job.counter || 0, // Use client's city or default
    folder_ref: job.folder_ref,
    completed: job.completed || false, // Use client's city or default
  }));

  return { rows, columns }; // Return rows and columns for the DataGrid
}

export function transformPaymentsToTable(
  payments = [],
  SendAgain,
  CancelPayment,
  searchValue,
  loadingData,
  handleGoFolder,
  tab
) {
  // only display sent payments

  // Define columns for DataGrid, customize based on your data structure
  // filter payments by search value
  if (searchValue !== null && searchValue !== undefined && searchValue !== "") {
    payments = payments.filter((payment) => payment.nom?.includes(searchValue));
  }
  if (tab === "current") {
    payments = payments.filter((payment) => payment.state !== "paid");
  } else {
    payments = payments.filter((payment) => payment.state === "paid");
  }
  const columns = [
    { field: "id", headerName: "ID", width: 300 },
    { field: "nom", headerName: "Nom", flex: 1 },
    { field: "first_name", headerName: "Prénom", flex: 1 },
    {
      field: "client_type",
      headerName: "Catégorie",
      width: 150,

      renderCell: (params) => {
        let client_type = params.value;
        let cat =
          params.value === "particulier"
            ? "Dossier particulier"
            : params.value === "architect"
              ? "Dossier pro"
              : params.value === "constructor"
                ? "Dossier pro"
                : "";
        return (
          <div
            className={`
              ${cat !== "Dossier particulier" ? "text-indigo-500  bg-indigo-50" : "text-blue-500  bg-blue-50"}
              inline-flex h-6 items-center rounded-lg px-2 py-2 border flex-row    font-light `}
          >
            {cat}
          </div>
        );
      },
    },

    { field: "email", headerName: "Email", flex: 1 },
    { field: "phone", headerName: "Téléphone", width: 110 },
    {
      field: "amount",
      headerName: "Montant",
      width: 80,
      renderCell: (params) => {
        const amount = params.value * 100;
        return (
          <div className="flex flex-row items-center h-full  ">
            {formatCentime(amount)}{" "}
          </div>
        );
      },
    },

    {
      field: "type",
      headerName: "Moyen",
      width: 80,
      renderCell: (params) => {
        const payment_type = params.value;
        const bridge_status = params.row.bridge?.status;

        return (
          <div className="flex flex-row items-center h-full  ">
            {payment_type === "card" && params.row.paid_date != 0 && (
              <div className="  bg-indigo-300 text-white  px-2 text-h2  w-fit  flex rounded-full h-5 items-center">
                stripe
              </div>
            )}
            {payment_type === "bridge" && bridge_status === "ACSC" && (
              <div className="  text-white bg-blue-300  px-2 text-h2  w-fit  flex rounded-full h-5 items-center">
                bridge
              </div>
            )}
            {bridge_status !== "ACSC" &&
              payment_type !== "card" &&
              params.row.state === "paid" && (
                <div className="  text-white bg-neutral-300  px-2 text-h2  w-fit  flex rounded-full h-5 items-center">
                  externe
                </div>
              )}
          </div>
        );
      },
    },
    {
      field: "date",
      headerName: "Dernier envoi",
      width: 150,
      renderCell: (params) => {
        const ini_date = params.value;
        return (
          <div className="flex flex-row items-center h-full  ">
            {ini_date && new Date(ini_date * 1000).toLocaleString()}
          </div>
        );
      },
    },
    {
      field: "state",
      headerName: "Status",
      width: 120,
      renderCell: (params) => {
        const status = params.value;
        const bridge_status = params.row.bridge?.status;
        const bridge_status_reason = params.row.bridge?.status_reason;
        return (
          <div className="flex flex-row items-center h-full  ">
            {status === "initiated" && (
              <div className="  text-white bg-neutral-400 px-2 text-h2  w-fit  flex rounded-full h-6 items-center">
                envoyée
              </div>
            )}
            {status === "opened" && !bridge_status && (
              <div className="  text-white bg-blue-300 px-2 text-h2  w-fit  flex rounded-full h-6 items-center ">
                lien cliqué
              </div>
            )}
            {status === "opened" && bridge_status === "PDNG" && (
              <div className="  text-white bg-orange-300 px-2 text-h2  w-fit  flex rounded-full h-6 items-center ">
                traitement
              </div>
            )}
            {status === "paid" && bridge_status !== "ACSC" && (
              <div className="  text-white bg-lime-300 px-2 text-h2 w-fit  flex rounded-full h-6 items-center ">
                payé
              </div>
            )}
            {status === "paid" && bridge_status === "ACSC" && (
              <div className="  text-white bg-green-300 px-2 text-h2 w-fit  flex rounded-full h-6 items-center ">
                payé
              </div>
            )}
            {status === "error" && (
              <Tippy
                content={getBridgeRejectionStatusExplanation(
                  bridge_status_reason
                )}
                placement="top"
                delay={100}
                className="custom-tooltip"
              >
                <div className="  text-white bg-red-300 px-2 text-h2  w-fit  flex rounded-full h-6 items-center ">
                  rejeté
                </div>
              </Tippy>
            )}
          </div>
        );
      },
    },
    // {
    //   field: "action",
    //   headerName: "Action",
    //   width: 190,

    //   renderCell: (params) => {
    //     const status = params.value;

    //     return (
    //       <div className="flex flex-row items-center h-full gap-2 ">
    //         <SecondaryButton
    //           disabled={["paid", "pending"].includes(params.row.state)}
    //           className={`w-fit ${
    //             moment().unix() - params.row.date < 3600 ? "opacity-75" : ""
    //           } `}
    //           onClick={(e) => {
    //             SendAgain(e, params.row.id);
    //           }}
    //         >
    //           Renvoyer
    //           <SmallSpinner
    //             loading={loadingData === params.row.id}
    //           ></SmallSpinner>
    //         </SecondaryButton>
    //         <SecondaryButton
    //           disabled={["paid", "error", "pending"].includes(params.row.state)}
    //           className="w-fit"
    //           onClick={(e) => {
    //             CancelPayment(e, params.row.ref);
    //           }}
    //         >
    //           Annuler
    //         </SecondaryButton>
    //         {/* <SecondaryButton
    //           className="w-fit max-h-6"
    //           onClick={(e) => handleGoFolder(e, params.row.folder_ref?.id)}
    //         >
    //           <Icon1 icon_name="folder" fill="grey"></Icon1>
    //         </SecondaryButton> */}
    //       </div>
    //     );
    //   },
    // },
    // Add more columns as needed
  ];

  // Create rows from the clients array
  const rows = payments.map((payment, index) => ({
    id: payment.id || index + 1, // Use client's ID or default index
    ref: payment.ref || null, // Include client's document reference
    nom: payment.nom || "", // Use client's name or default 'Unknown'
    first_name: payment.reglement_infos?.first_name || "", // Use client's name or default 'Unknown'
    email: payment.reglement_infos?.email || payment?.reglement?.email || "", // Use client's name or default 'Unknown'
    phone: payment.reglement_infos?.phone || payment?.reglement?.phone || "", // Use client's name or default 'Unknown'
    amount: payment?.amount || payment.reglement_infos?.amount || "", // Use client's name or default 'Unknown'
    type: payment.type || "", // Use client's type or default
    date: payment.paid_date?.seconds || payment.initiation_seconds, // Use client's city or default
    state: payment.state, // Use client's city or default
    client_type: payment.client_type || "", // Use client's type or default
    folder_ref: payment.folder_ref || null, // Use client's type or default
    paid_date: payment.paid_date?.seconds || 0, // Use client's type or default
    bridge: payment.bridge || null, // Use client's type or default
  }));

  return { rows, columns }; // Return rows and columns for the DataGrid
}

export function transformPhotosToTable(photos, searchValue, setBigPhoto) {
  // Define columns for DataGrid, customize based on your data structure
  // filter payments by search value

  if (searchValue !== null && searchValue !== undefined && searchValue !== "") {
    photos = photos.filter((photo) =>
      (
        (photo.control_name || "") +
          "_" +
          (photo.champs_name || "") +
          "_" +
          photo.name || ""
      )
        ?.toLocaleLowerCase()
        .includes(searchValue.toLocaleLowerCase())
    );
  }

  const columns = [
    { field: "id", headerName: "ID", width: 300 },
    { field: "name", headerName: "Nom", flex: 1 },

    {
      field: "url",
      headerName: "Url",
      width: 200,
      renderCell: (params) => {
        const url = params.value;
        return (
          <div
            className="flex flex-row items-center h-full"
            onClick={(e) => {
              setBigPhoto(url); // Pass the full image URL to setBigPhoto
              e.stopPropagation(); // Prevent click propagation
            }}
          >
            <img
              src={url}
              alt="photo"
              className="h-20 w-20 object-scale-down rounded-md hover:border-3 hover:border-blue-500"
            />
          </div>
        );
      },
    },

    {
      field: "date",
      headerName: "Date de création",
      width: 300,
      renderCell: (params) => {
        const ini_date = params.value;
        return (
          <div className="flex flex-row items-center h-full  ">
            {ini_date && new Date(ini_date * 1000).toLocaleString()}
          </div>
        );
      },
    },

    // Add more columns as needed
  ];

  // Create rows from the clients array
  const rows = photos.map((photo, index) => ({
    id: photo.id || index + 1, // Use client's ID or default index
    ref: photo.ref || null, // Include client's document reference
    name:
      (photo.control_name || "") +
        "_" +
        (photo.champs_name || "") +
        "_" +
        "_" +
        photo.name || "", // Use client's name or default 'Unknown'
    date: photo.date.seconds, // Use client's city or default
    url: photo.url, // Use client's city or default
  }));

  return { rows, columns }; // Return rows and columns for the DataGrid
}

export function transformAdminPaymentsToTable(
  payments,

  searchValue,

  tab
) {
  payments = payments.filter((payment) => payment.type === "bridge");
  if (tab === "current") {
    payments = payments.filter((payment) => payment.admin_tab !== "archived");
  } else {
    payments = payments.filter((payment) => payment.admin_tab === "archived");
  }
  // Define columns for DataGrid, customize based on your data structure
  // filter payments by search value
  if (searchValue !== null && searchValue !== undefined && searchValue !== "") {
    payments = payments.filter((payment) => payment.nom?.includes(searchValue));
  }

  const columns = [
    { field: "id", headerName: "ID", width: 170 },
    { field: "nom", headerName: "Nom", width: 150 },

    { field: "email", headerName: "Email", width: 200 },
    { field: "phone", headerName: "Téléphone", width: 100 },
    {
      field: "amount",
      headerName: "Montant",
      width: 80,
      renderCell: (params) => {
        const amount = params.value;
        return (
          <div className="flex flex-row items-center h-full  ">
            {formatCentime(amount * 100)}
          </div>
        );
      },
    },

    {
      field: "state",
      headerName: "Status",
      width: 100,
      renderCell: (params) => {
        const status = params.value;
        return (
          <div className="flex flex-row items-center h-full  ">
            {status === "initiated" && (
              <div className="  text-white bg-neutral-300 px-2 text-h3  w-fit  flex rounded-full h-5 items-center">
                envoyée
              </div>
            )}
            {status === "opened" && (
              <div className="  text-white bg-blue-300 px-2 text-h3  w-fit  flex rounded-full h-5 items-center ">
                lien cliqué
              </div>
            )}
            {status === "pending" && (
              <div className="  text-white bg-orange-300 px-2 text-h3  w-fit  flex rounded-full h-5 items-center ">
                processing
              </div>
            )}
            {status === "paid" && (
              <div className="  text-white bg-green-300 px-2 text-h3  w-fit  flex rounded-full h-5 items-center ">
                payée
              </div>
            )}
            {status === "error" && (
              <div className="  text-white bg-red-300 px-2 text-h3  w-fit  flex rounded-full h-5 items-center ">
                echec
              </div>
            )}
          </div>
        );
      },
    },
    {
      field: "last_updated",
      headerName: "Last updated",
      width: 150,
      renderCell: (params) => {
        const seconds = params.value;
        return (
          <div className="flex flex-row items-center h-full  ">
            {new Date(seconds * 1000).toLocaleString()}
          </div>
        );
      },
    },
    { field: "iban", headerName: "iban", width: 200 },

    {
      field: "bridge_status",
      headerName: "Bridge",
      width: 150,
      renderCell: (params) => {
        const status = params.value;
        return (
          <div className="flex flex-row items-center h-full  ">
            {status === "ACTC" && (
              <div className="  text-white bg-neutral-300 px-2 text-h2  w-fit  flex rounded-full h-5 items-center">
                started
              </div>
            )}
            {status === "PDNG" && (
              <div className="  text-white bg-blue-300 px-2 text-h2  w-fit  flex rounded-full h-5 items-center ">
                pending
              </div>
            )}
            {status === "ACSC" && (
              <div className="  text-white bg-green-300 px-2 text-h2  w-fit  flex rounded-full h-5 items-center ">
                transfered
              </div>
            )}

            {status === "RJCT" && (
              <div className="  text-white bg-red-300 px-2 text-h2  w-fit  flex rounded-full h-5 items-center ">
                rejected
              </div>
            )}

            {status === null && (
              <div className="  text-white bg-red-300 px-2 text-h2  w-fit  flex rounded-full h-5 items-center ">
                unknown
              </div>
            )}
          </div>
        );
      },
    },

    // Add more columns as needed
  ];

  // Create rows from the clients array
  const rows = payments.map((payment, index) => ({
    id: payment.id || index + 1, // Use client's ID or default index
    ref: payment.ref || null, // Include client's document reference
    nom: payment.nom || "", // Use client's name or default 'Unknown'
    email: payment.reglement_infos?.email || "", // Use client's name or default 'Unknown'
    phone: payment.reglement_infos?.phone || "", // Use client's name or default 'Unknown'
    amount: payment.amount || "", // Use client's name or default 'Unknown'
    type: payment.type || "", // Use client's type or default
    date: payment.initiation_seconds, // Use client's city or default
    state: payment.state, // Use client's city or default
    bridge_status: payment.bridge?.status, // Use client's city or default
    last_updated: payment.last_updated?.seconds || null, // Use client's type or default
    iban: payment.bridge?.beneficiary?.iban,
  }));

  return { rows, columns }; // Return rows and columns for the DataGrid
}

// Transform clients into a DataGrid-friendly format
export function transformUsersToTable(users) {
  // Define columns for DataGrid, customize based on your data structure
  const columns = [
    { field: "id", headerName: "ID", width: 300 },
    { field: "email", headerName: "Email", width: 250 },
    { field: "display_name", headerName: "Nom", width: 200 },

    {
      field: "last_connexion",
      headerName: "Last connexion",
      width: 150,
      renderCell: (params) => {
        // check if the date is today

        let isToday = moment(params.value * 1000).isSame(moment(), "day");
        let isYesterday = moment(params.value * 1000).isSame(
          moment().subtract(1, "days"),
          "day"
        );
        let formattedDate = moment(params.value * 1000).format("HH:mm");
        return (
          <>
            {params.value !== 0 && (
              <>
                {isToday && (
                  <div className="text-green-600">
                    Auj
                    <span className="text-shadow_50"> {formattedDate}</span>
                  </div>
                )}
                {isYesterday && (
                  <div className="text-yellow-600">
                    Hier
                    <span className="text-shadow_50"> {formattedDate}</span>
                  </div>
                )}
                {!isToday && !isYesterday && (
                  <div>{new Date(params.value * 1000).toLocaleString()}</div>
                )}
              </>
            )}
          </>
        );
      },
    },
    {
      field: "activity_time",
      headerName: "Use time",
      width: 120,
      renderCell: (params) => {
        let hours = Math.round(params.value / 3600) || 0;
        let minutes = Math.round((params.value % 3600) / 60) || 0;
        let seconds = Math.round(params.value % 60) || 0;
        return (
          <>
            {params.value !== 0 && <div>{hours + "h " + minutes + "min"}</div>}
          </>
        );
      },
    },
    {
      field: "creation_time",
      headerName: "Creation",
      width: 120,
      renderCell: (params) => {
        return (
          <div
            className={`${params.value === 0 ? "text-shadow_25" : "text-shadow_50"}`}
          >
            {params.value
              ? new Date(params.value * 1000).toLocaleString()
              : "never"}
          </div>
        );
      },
    },
    {
      field: "feedback",
      headerName: "Note",
      width: 100,
      renderCell: (params) => {
        if (!params.value) {
          return;
        }
        return (
          <>
            {params.value.ask && (
              <div className="flex flex-row gap-2 h-full w-full items-center text-red-500">
                <div className="h-2 w-2 rounded-full bg-red-500 "></div>
                Asked
              </div>
            )}
            {!params.value.ask && params.value.grade && (
              <div className="flex flex-row gap-2 h-full w-full items-center text-shadow_50">
                {params.value.grade}
              </div>
            )}
          </>
        );
      },
    },
    {
      field: "isonline",
      headerName: "Online",
      width: 200,
      renderCell: (params) => {
        return (
          <>
            {params.value && (
              <div className="flex flex-row gap-2 w-full items-center">
                <div className="bg-green_simple rounded-full h-3 w-3"></div>
                <div className="">En ligne</div>
              </div>
            )}
            {!params.value && (
              <div className="flex flex-row gap-2 w-full items-center">
                <div className="bg-shadow_25 rounded-full h-3 w-3"></div>
                <div className="text-shadow_50">Hors ligne</div>
              </div>
            )}
          </>
        );
      },
    },
    {
      field: "type",
      headerName: "Type",
      width: 250,
      renderCell: (params) => {
        const beta_type = params.value;
        return (
          <>
            {beta_type === "fake" && (
              <div className="  py-0.5 text-shadow_50 bg-orange-100 px-2 text-h2 font-semibold w-fit rounded-full">
                FAKE
              </div>
            )}
            {beta_type === "denys_related" && (
              <div className="  py-0.5 text-shadow_50 bg-green-100 px-2 text-h2 font-semibold w-fit rounded-full">
                DENYS
              </div>
            )}
            {beta_type === "" && (
              <div className="  py-0.5 text-shadow_25 bg-neutral-200 px-2 text-h2 font-semibold w-fit rounded-full">
                UNSET
              </div>
            )}
          </>
        );
      },
    },

    // Add more columns as needed
  ];

  // Create rows from the clients array
  const rows = users.map((user, index) => ({
    id: user.id || index + 1, // Use client's ID or default index
    ref: user.ref || null, // Include client's document reference
    display_name: user.display_name || "", // Use client's name or default 'Unknown'
    email: user.email || "", // Use client's name or default 'Unknown'
    last_connexion: user?.tracking?.last_connection?.seconds || 0, // Use client's type or default
    feedback: user?.tracking?.feedback,
    creation_time: user.creation_time?.seconds || 0,

    type: user.beta_type || "", // Use client's name or default 'Unknown'
    isonline: user.tracking?.isonline || false, // Use client's city or default
    activity_time: user.tracking?.activity_seconds || 0, // Use client's city or default
  }));

  return { rows, columns }; // Return rows and columns for the DataGrid
}

// Transform clients into a DataGrid-friendly format
export function transformGuestsToTable(sessions) {
  // Define columns for DataGrid, customize based on your data structure
  const columns = [
    { field: "id", headerName: "ID", width: 300 },

    { field: "email", headerName: "Email", width: 250 },

    {
      field: "date",
      headerName: "Date",
      width: 150,
      renderCell: (params) => {
        // check if the date is today

        let isToday = moment(params.value * 1000).isSame(moment(), "day");
        let isYesterday = moment(params.value * 1000).isSame(
          moment().subtract(1, "days"),
          "day"
        );
        let formattedDate = moment(params.value * 1000).format("HH:mm");
        return (
          <>
            {params.value !== 0 && (
              <>
                {isToday && (
                  <div className="text-green-600">
                    Auj
                    <span className="text-shadow_50"> {formattedDate}</span>
                  </div>
                )}
                {isYesterday && (
                  <div className="text-yellow-600">
                    Hier
                    <span className="text-shadow_50"> {formattedDate}</span>
                  </div>
                )}
                {!isToday && !isYesterday && (
                  <div>{new Date(params.value * 1000).toLocaleString()}</div>
                )}
              </>
            )}
          </>
        );
      },
    },

    {
      field: "master",
      headerName: "Master",
      flex: 1,
    },
    {
      field: "special",
      headerName: "Special",
      flex: 1,
    },
    // Add more columns as needed
  ];

  // Create rows from the clients array
  const rows = sessions.map((session, index) => ({
    id: session.id, // Use client's ID or default index
    email: session.email || "", // Use client's name or default 'Unknown'
    date: session?.date.seconds || 0, // Use client's type or default
    master: session?.org_id || "",

    special: session.special || "", // Use client's city or default
  }));

  return { rows, columns }; // Return rows and columns for the DataGrid
}

// Transform clients into a DataGrid-friendly format
export function transformSetupSessionsToTable(sessions) {
  // Define columns for DataGrid, customize based on your data structure
  const columns = [
    { field: "id", headerName: "ID", width: 300 },

    { field: "email", headerName: "Email", width: 250 },

    {
      field: "date",
      headerName: "Date",
      width: 150,
      renderCell: (params) => {
        // check if the date is today

        let isToday = moment(params.value * 1000).isSame(moment(), "day");
        let isYesterday = moment(params.value * 1000).isSame(
          moment().subtract(1, "days"),
          "day"
        );
        let formattedDate = moment(params.value * 1000).format("HH:mm");
        return (
          <>
            {params.value !== 0 && (
              <>
                {isToday && (
                  <div className="text-green-600">
                    Auj
                    <span className="text-shadow_50"> {formattedDate}</span>
                  </div>
                )}
                {isYesterday && (
                  <div className="text-yellow-600">
                    Hier
                    <span className="text-shadow_50"> {formattedDate}</span>
                  </div>
                )}
                {!isToday && !isYesterday && (
                  <div>{new Date(params.value * 1000).toLocaleString()}</div>
                )}
              </>
            )}
          </>
        );
      },
    },

    {
      field: "user_id",
      headerName: "User",
      flex: 1,
    },

    // Add more columns as needed
  ];

  // Create rows from the clients array
  const rows = sessions.map((session, index) => ({
    id: session.id, // Use client's ID or default index
    email: session.email || "", // Use client's name or default 'Unknown'
    date: session?.last_opened_date?.seconds || 0, // Use client's type or default
    user_id: session?.user_id || "",
  }));

  return { rows, columns }; // Return rows and columns for the DataGrid
}

// Transform clients into a DataGrid-friendly format
export function transformLogsToTable(
  logs,
  theme,
  searchvalue = "",
  nopresigned = true,
  noupdate = true,
  nolocalhost = false
) {
  // Define columns for DataGrid, customize based on your data structure

  // remove logs with url contains "presigned"
  if (nopresigned) {
    logs = logs.filter((log) =>
      log?.url && typeof log.url === "string"
        ? !log.url.includes("presigned")
        : true
    );
  }
  if (noupdate) {
    logs = logs.filter((log) =>
      log?.url && typeof log.url === "string"
        ? !log.url.includes("update-doc-data-field")
        : true
    );
  }
  if (nolocalhost) {
    logs = logs.filter((log) =>
      log?.url && typeof log.url === "string"
        ? !log.url.includes("127.0.0.1")
        : true
    );
  }

  const columns = [
    {
      field: "date",
      headerName: "Date",
      width: 150,
      renderCell: (params) => {
        // Customize color based on status value
        const date = params.value;
        return <div>{dayjs.unix(date).format("DD/MM/YYYY HH:mm:ss")}</div>;
      },
    },

    {
      field: "delay",
      headerName: "Délai",
      width: 80,
      renderCell: (params) => {
        const msseconds = params.value;

        if (msseconds === 0) {
          return <div></div>;
        }
        // Customize color based on status value
        return <div>{msseconds + " ms"}</div>;
      },
    },

    { field: "type", headerName: "Type", width: 80 },

    { field: "url", headerName: "Url", width: 250 },

    {
      field: "status",
      headerName: "Status",
      width: 100,
      renderCell: (params) => {
        // Customize color based on status value
        const status = params.value;
        let textColor;
        let backgroundColor;

        if (status >= 500) {
          textColor = theme.palette.accent2.main; // Error status text color
          backgroundColor = theme.palette.accent2.light; // Error status background
        } else if (status >= 400) {
          textColor = theme.palette.accent3.main; // Warning status text color
          backgroundColor = theme.palette.accent3.light; // Warning status background
        } else {
          textColor = theme.palette.accent1.main; // Success status text color
          backgroundColor = theme.palette.accent1.light; // Success status background
        }

        return (
          <div
            style={{
              backgroundColor: backgroundColor, // Set background color
              color: textColor, // Set text color
              borderRadius: "30px", // Add rounded corners
              padding: "2px 8px", // Add padding
            }}
          >
            <span>{status}</span>
          </div>
        );
      },
    },

    { field: "email", headerName: "Email", width: 250 },

    { field: "org", headerName: "Org", width: 150 },

    // Add more columns as needed
  ];

  if (searchvalue !== "") {
    logs = logs.filter((log) => (log.url + log.email)?.includes(searchvalue));
  }

  // Create rows from the clients array
  const rows = logs.map((log, index) => ({
    id: log.id || index + 1, // Use client's ID or default index
    ref: log.ref || null, // Include client's document reference
    date: log.date.seconds || 0,
    delay: parseInt(log.delay) || 0,

    url:
      typeof log.url === "string"
        ? log.url.replace("https://api.hexagone.expert/", "")
        : "",
    type: log.type || "", // Use client's type or default

    status: log.status || "", // Use client's type or default
    org: log.org_id || "", // Use client's city or default
    email: log.email || "", // Use client's city or default
  }));

  return { rows, columns }; // Return rows and columns for the DataGrid
}

// Transform clients into a DataGrid-friendly format
export function transformAppLogsToTable(
  applogs,
  theme,
  searchvalue = "",
  nopresigned = true,
  noupdate = true
) {
  if (searchvalue !== "") {
    applogs = applogs.filter((log) => log.email?.includes(searchvalue));
  }

  const columns = [
    {
      field: "date",
      headerName: "Date",
      width: 150,
      renderCell: (params) => {
        // Customize color based on status value
        const seconds = params.value;
        return <div>{dayjs.unix(seconds).format("DD/MM/YYYY HH:mm:ss")}</div>;
      },
    },

    { field: "email", headerName: "Type", flex: 1 },

    { field: "length", headerName: "Taille", width: 100 },

    // Add more columns as needed
  ];

  // Create rows from the clients array
  const rows = applogs.map((log, index) => ({
    id: log.id || index + 1, // Use client's ID or default index
    ref: log.ref || null, // Include client's document reference
    date: log.date.seconds || 0,
    email: log.email || "", // Use client's type or default
    length: log.logs.length || 0, // Use client's city or default
  }));

  return { rows, columns }; // Return rows and columns for the DataGrid
}

// Transform clients into a DataGrid-friendly format
export function transformTicketsToTable(tickets, theme, searchvalue = "") {
  if (searchvalue !== "") {
    tickets = tickets.filter((log) => log.email?.includes(searchvalue));
  }

  const columns = [
    {
      field: "date",
      headerName: "Date",
      width: 130,
      renderCell: (params) => {
        // Customize color based on status value
        const date = params.value;
        return (
          <div>
            {new Date(date).toLocaleString("fr-FR", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              hour12: false,
            })}
          </div>
        );
      },
    },

    { field: "email", headerName: "Email", flex: 1 },

    { field: "length", headerName: "Taille", width: 80 },
    {
      field: "status",
      headerName: "status",
      width: 120,

      renderCell: (params) => {
        const status = params.value;
        return (
          <div className="flex flex-row items-center h-full  ">
            {status === "open" && (
              <div className="  text-shadow_50 bg-orange-100 px-2 text-h2  w-fit  flex rounded-full h-5 items-center ">
                Ouvert
              </div>
            )}
            {status === "resolved" && (
              <div className="  text-shadow_50 bg-green-100 px-2 text-h2  w-fit  flex rounded-full h-5 items-center ">
                Resolved
              </div>
            )}
            {status === "blocked" && (
              <div className="  text-shadow_50 bg-red-100 px-2 text-h2  w-fit  flex rounded-full h-5 items-center ">
                Blocked
              </div>
            )}
          </div>
        );
      },
    },

    // Add more columns as needed
  ];

  // Create rows from the clients array
  const rows = tickets.map((log, index) => ({
    id: log.id || index + 1, // Use client's ID or default index
    ref: log.ref || null, // Include client's document reference
    date: log.date.seconds * 1000 || 0,
    email: log.email || "", // Use client's type or default
    length: log.message.length || 0, // Use client's city or default
    oid: log.oid || "",
    type: log.type || "",
    num: log.ticket_num || "",
    status: log.status || "",
    message: log.message || "",
    admin_user_email: log.admin_user_email || "",
  }));

  return { rows, columns }; // Return rows and columns for the DataGrid
}

// Transform clients into a DataGrid-friendly format
export function transformTransactionsToTable(
  transactions,
  theme,
  searchvalue = "",
  handleDeactivateTransaction
) {
  // Define columns for DataGrid, customize based on your data structure

  // remove logs with url contains "presigned"
  const columns = [
    { field: "id", headerName: "id", width: 200 },

    {
      field: "date",
      headerName: "Date",
      width: 150,
      renderCell: (params) => {
        // Customize color based on status value
        const date = params.value;
        return (
          <div>
            {new Date(date).toLocaleString("fr-FR", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              hour12: false,
            })}
          </div>
        );
      },
    },

    {
      field: "amount",
      headerName: "Amount",
      width: 120,
      renderCell: (params) => {
        // Customize color based on status value
        const amount = params.value;
        return <div>{formatToCentimes(amount / 100)}</div>;
      },
    },
    { field: "type", headerName: "Type", width: 120 },
    { field: "process", headerName: "Process", width: 150 },
    { field: "name", headerName: "Name", width: 200 },

    { field: "destination_type", headerName: "Destination", width: 120 },
    { field: "master_id", headerName: "Master", width: 200 },
    {
      field: "status",
      headerName: "Status",
      width: 120,
      renderCell: (params) => {
        const status = params.value;

        if (params.row.ignored) {
          return (
            <div className="flex flex-row items-center h-full  ">
              <div className="  text-shadow_50 bg-gray-100 px-2 text-h2  w-fit  flex rounded-full h-5 items-center ">
                Ignored
              </div>
            </div>
          );
        }
        return (
          <div className="flex flex-row items-center h-full  ">
            {status === "unpaid" && (
              <div className="  text-shadow_50 bg-orange-100 px-2 text-h2  w-fit  flex rounded-full h-5 items-center ">
                Unpaid
              </div>
            )}
            {status === "paid" && (
              <div className="  text-shadow_50 bg-green-100 px-2 text-h2  w-fit  flex rounded-full h-5 items-center ">
                Payed
              </div>
            )}
            {status === "error" && (
              <div className="  text-shadow_50 bg-red-100 px-2 text-h2  w-fit  flex rounded-full h-5 items-center ">
                Error
              </div>
            )}
          </div>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 120,
      renderCell: (params) => {
        const status = params.value;
        return (
          <div className="flex flex-row items-center h-full  ">
            <SecondaryButton
              className={params.row.ignored ? "text-gray-400" : ""}
              onClick={() => handleDeactivateTransaction(params.row.id)}
            >
              {params.row.ignored ? "Réactiver" : "Désactiver"}
            </SecondaryButton>
          </div>
        );
      },
    },

    // Add more columns as needed
  ];

  if (searchvalue !== "") {
    transactions = transactions.filter((transaction) =>
      transaction.product.type?.includes(searchvalue)
    );
  }

  // Create rows from the clients array
  const rows = transactions.map((tran, index) => ({
    id: tran.id || index + 1, // Use client's ID or default index
    ref: tran.ref || null, // Include client's document reference
    date: tran.date.seconds * 1000 || 0,
    amount: parseInt(tran.amount) || 0,
    process: tran.process || "",
    type:
      tran.product.type === "fees"
        ? "fees : " + (tran.product.rate || 0) * 100 + "%"
        : tran.product.type,
    name: tran.name || "",
    destination_type: tran.destination.type || "",
    master_id: tran.origin?.master_id || tran.destination?.master_id || "",
    status: tran.status || "",
    ignored: tran.ignored || false,
  }));

  return { rows, columns }; // Return rows and columns for the DataGrid
}

// Transform clients into a DataGrid-friendly format
export function transformPayoutsToTable(payouts, theme, searchvalue = "") {
  // Define columns for DataGrid, customize based on your data structure

  // remove logs with url contains "presigned"

  const columns = [
    { field: "id", headerName: "id", width: 200 },

    {
      field: "date",
      headerName: "Date",
      width: 150,
      renderCell: (params) => {
        // Customize color based on status value
        const date = params.value;
        return (
          <div>
            {new Date(date).toLocaleString("fr-FR", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              hour12: false,
            })}
          </div>
        );
      },
    },

    {
      field: "amount",
      headerName: "Amount",
      width: 120,
      renderCell: (params) => {
        // Customize color based on status value
        const amount = params.value;
        return <div>{formatToCentimes(amount / 100)}</div>;
      },
    },
    { field: "name", headerName: "Name", width: 200 },

    { field: "bank_ref", headerName: "Banque", width: 120 },
    { field: "master_id", headerName: "Master", width: 200 },
    {
      field: "status",
      headerName: "Status",
      width: 120,
      renderCell: (params) => {
        const status = params.value;
        return (
          <div className="flex flex-row items-center h-full  ">
            {status !== "paid" && (
              <div className="  text-shadow_50 bg-orange-100 px-2 text-h2  w-fit  flex rounded-full h-5 items-center ">
                Pending
              </div>
            )}
            {status === "paid" && (
              <div className="  text-shadow_50 bg-green-100 px-2 text-h2  w-fit  flex rounded-full h-5 items-center ">
                Received
              </div>
            )}
            {status === "error" && (
              <div className="  text-shadow_50 bg-red-100 px-2 text-h2  w-fit  flex rounded-full h-5 items-center ">
                Error
              </div>
            )}
          </div>
        );
      },
    },
    { field: "transation_id", headerName: "transation_id", width: 150 },

    // Add more columns as needed
  ];

  // Create rows from the clients array
  const rows = payouts.map((tran, index) => ({
    id: tran.id || index + 1, // Use client's ID or default index
    ref: tran.ref || null, // Include client's document reference
    date: tran.date.seconds * 1000 || 0,
    amount: parseInt(tran.amount) || 0,
    transation_id: tran.transaction_ref?.id || "",
    name: tran.name || "",
    bank_ref: tran.bank_ref || "",
    master_id: tran.master_id || "",
    status: tran.status || "",
  }));

  return { rows, columns }; // Return rows and columns for the DataGrid
}

// Transform clients into a DataGrid-friendly format
export function transformExpertsToTable(experts) {
  // Define columns for DataGrid, customize based on your data structure
  const columns = [
    { field: "id", headerName: "ID", width: 200 },

    { field: "name", headerName: "Nom", flex: 1 },
    { field: "email", headerName: "Email", flex: 2 },

    { field: "ville", headerName: "Ville", flex: 1 },

    // Add more columns as needed
  ];

  // Create rows from the clients array
  let rows = experts.map((expert, index) => ({
    id: expert.id || index + 1, // Use client's ID or default index
    ref: expert.ref || null, // Include client's document reference
    name: expert.name || "", // Use client's name or default 'Unknown'
    email: expert.email || "", // Use client's name or default 'Unknown'
    ville: expert.ville || "", // Use client's city or default$
  }));

  rows = rows.sort((a, b) => {
    return a.name.trim().localeCompare(b.name.trim());
  });

  return { rows, columns }; // Return rows and columns for the DataGrid
}

// Transf

export function isArchived(folder, orgData) {
  if (!orgData) {
    console.error("isArchived: orgData is null");
    return false;
  } else if (!folder.visions) {
    console.error("isArchived: folder_id : " + folder.id + "  visions is null");
    return false;
  } else {
    const vision = folder.visions.find(
      (vision) => vision.org_id === orgData.id
    );
    if (vision) {
      if (vision.state === "archived") {
        return true;
      } else {
        return false;
      }
    } else {
      console.error(
        "isArchived: vision is null folder_id " +
          folder.id +
          " " +
          folder.nom +
          " org : " +
          orgData.name +
          " visions : " +
          (folder.visions.map((vision) => vision.org_id).flat() || [])
      );
      console.error(folder.visions);
      return false;
    }
    return false;
  }
  return false;
}

export function intToHexColor(intColor) {
  return `#${(intColor >>> 0).toString(16).slice(-6)}`;
}

export function isColorTooDark(hexColor) {
  // Remove the "#" if present
  hexColor = hexColor.replace("#", "");

  // Convert hex to RGB
  const r = parseInt(hexColor.substring(0, 2), 16);
  const g = parseInt(hexColor.substring(2, 4), 16);
  const b = parseInt(hexColor.substring(4, 6), 16);

  // Calculate the luminance using the relative luminance formula
  const luminance = 0.299 * r + 0.637 * g + 0.114 * b;

  // Return true if the luminance is below a threshold (128 is a common midpoint)
  return luminance < 170;
}

export function rgbaToHex(rgba) {
  const rgbaValues = rgba
    .replace(/^rgba?\(|\s+|\)$/g, "")
    .split(",")
    .map((value) => parseFloat(value.trim()));

  const [r, g, b, a = 1] = rgbaValues; // Default alpha to 1 if not provided

  const rHex = Math.round(r).toString(16).padStart(2, "0");
  const gHex = Math.round(g).toString(16).padStart(2, "0");
  const bHex = Math.round(b).toString(16).padStart(2, "0");
  const aHex = Math.round(a * 255)
    .toString(16)
    .padStart(2, "0"); // Convert 0-1 to 0-255

  return `#${rHex}${gHex}${bHex}${aHex}`;
}
export function adjustColorOpacity(hex, alpha) {
  // Helper function to convert hex to RGBA
  function hexToRgba(hex, alpha) {
    // Remove the '#' if present
    hex = hex.replace("#", "");
    // Parse the hex color into RGB
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  // Ensure alpha is between 0 and 1
  alpha = Math.max(0, Math.min(1, alpha));

  return hexToRgba(hex, alpha);
}

function getStatus(list_visions, realisee, orgData) {
  let org_state = "";
  let label = "";
  for (const vision of list_visions) {
    if (vision.org_id === orgData.id) {
      org_state = vision.state;
    }
  }

  if (org_state === "archived") {
    label = "Archivé";
  } else if (org_state === "current") {
    label = realisee ? "Réalisé" : "A venir";
  } else if (org_state === "deleted") {
    label = "Supprimé";
  }
  return label;
}

export function transformFoldersToTable(
  folders,
  activetab,
  orgData,
  userData,
  theme,
  openTag,
  searchValue,
  year,
  searchFolders,
  tag_filters = [],
  users = [],
  partners = [],
  workspaceData,
  all_workspaces,
  only_folder_filter = null,
  audit_folder_filter = null
) {
  try {
    let operators = [...users];
    let conductors = [...users];
    if (only_folder_filter === "particulier") {
      folders = folders.filter((folder) => {
        return folder.client_type === "particulier";
      });
    } else if (only_folder_filter === "late") {
      folders = folders.filter((folder) => {
        return (
          folder.late == true &&
          !folder.revisions?.length &&
          folder.reglement?.state !== "wait" &&
          folder.revisions?.length !== 0
        );
      });
    } else if (only_folder_filter === "blocked") {
      folders = folders.filter((folder) => {
        return folder.blocked == true;
      });
    } else if (only_folder_filter === "rdv") {
      folders = folders.filter((folder) => {
        return !folder.dateintervention?.seconds && folder.rdv_state === "wait";
      });
    } else if (only_folder_filter === "xml") {
      folders = folders.filter((folder) => {
        return (
          folder.xml?.requested == true &&
          !["wait", "done"].includes(folder.xml?.state)
        );
      });
    } else if (only_folder_filter === "modif") {
      folders = folders.filter((folder) => {
        return (
          folder.modif_thermal?.activated == true &&
          !["wait", "done"].includes(folder.modif_thermal?.state)
        );
      });
    } else if (only_folder_filter === "revision") {
      folders = folders.filter((folder) => {
        return (
          folder.reglement_state != "done" && folder.revisions?.length === 0
        );
      });
    }
    if (audit_folder_filter && audit_folder_filter !== "Tous les dossiers") {
      folders = folders.filter((folder) => {
        return folder.timeline?.current_step
          ? audit_folder_filter ===
              audit_steps_titles[folder.timeline?.current_step || 0]
          : false;
      });
    }
    if (searchValue !== "" && searchFolders === "folders") {
      folders = folders.filter((folder) => folder.nom === searchValue);
    } else if (searchValue !== "" && searchFolders === "clients") {
      // search by client name

      folders = folders.filter((folder) => {
        if (folder.marque) {
          return folder.marque?.trim() === searchValue;
        } else {
          return folder.folder_entreprise_name?.trim() === searchValue;
        }
      });
    } else if (searchValue !== "" && searchFolders === "partners") {
      // search by client name

      folders = folders.filter((folder) => {
        if (folder.partners_id) {
          let partner_names = partners
            .filter((partner) => {
              return folder.partners_id.includes(partner.id);
            })
            .map((partner) => partner.name);
          return partner_names.includes(searchValue);
        } else {
        }
      });
    } else {
      if (activetab === "programmed") {
        folders = folders.filter(
          (folder) => folder.intervention_realisee === false
        );
        folders = folders.filter(
          (folder) => isArchived(folder, orgData) === false
        );
      } else if (activetab === "done") {
        // intervention réalisée
        folders = folders.filter(
          (folder) => folder.intervention_realisee === true
        );
        folders = folders.filter(
          (folder) => isArchived(folder, orgData) === false
        );
      } else if (activetab === "archived") {
        folders = folders.filter(
          (folder) => isArchived(folder, orgData) === true
        );
      }
    }
    if (year) {
      folders = folders.filter((folder) => {
        const date = new Date(folder.created_time?.seconds * 1000);

        return date.getFullYear() === year;
      });
    }

    if (tag_filters.length > 0) {
      let endfolders = [];
      for (let folder of folders) {
        let tags = folder.tags || [];
        let tags2 = folder.tags2 || [];

        let tag_names = tags
          .filter((tag) => tag.org_id === orgData.id)
          .map((tag) => tag.nom);
        let tag_names2 = tags2
          .filter((tag) => tag.org_id === orgData.id)
          .map((tag) => tag.nom);
        if (tag_names.length === 0 && tag_names2.length === 0) {
          tag_names = ["Pas de tag"];
        }

        let all_tags = [...tag_names, ...tag_names2];
        let keeping = true;
        for (let tag of tag_filters) {
          if (!all_tags.includes(tag)) {
            keeping = false;
            break;
          }
        }
        if (keeping) {
          endfolders.push(folder);
        }
      }
      folders = endfolders;
    }
    if (!userData) {
      console.error("userData is null");
      return { rows: [], columns: [] };
    }

    if (
      orgData.restrictions?.operator_limited &&
      userData.role === "operator"
    ) {
      folders = folders.filter((folder) => {
        return folder.members_id?.find((member) => member.id === userData.id);
      });
    }
    if (
      orgData.restrictions?.conductor_limited &&
      userData.role === "conductor"
    ) {
      folders = folders.filter((folder) => {
        return folder.conductor_id === userData.id;
      });
    }

    // Define columns for DataGrid, customize based on your data structure
    const columns = [
      { field: "id", headerName: "ID", width: 300 },

      { field: "num", headerName: "Numéro", width: 100 },

      {
        field: "nom",
        headerName: "Nom",
        width: 170,
        renderCell: (params) => {
          return (
            <div className={`flex flex-row gap-1 items-center  h-6 `}>
              {params.value}
            </div>
          );
        },
      },
      { field: "first_name", headerName: "Prénom", width: 100 },
      {
        field: "phone",
        headerName: "Téléphone",
        width: 130,

        renderCell: (params) => {
          let phone = params.value;
          // format as 06 12 34 56 78
          if (phone && phone.length === 10) {
            phone = phone.replace(
              /(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/,
              "$1 $2 $3 $4 $5"
            );
          }

          return (
            <div className="flex flex-row gap-1 items-center  h-6 ">
              {phone}
            </div>
          );
        },
      },

      { field: "postal", headerName: "Postal", width: 80 },
      { field: "ville", headerName: "Ville", width: 140 },

      {
        field: "entreprise_name",
        headerName: "Client/Marque",
        width: 120,

        renderCell: (params) => {
          return (
            <div
              className={`inline-flex h-6 items-center border rounded-lg px-2 py-2 flex-row ${params.row.payment_allowed === false ? "text-indigo-500 bg-indigo-50" : params.value?.trim() === "Particulier" ? "text-purple-500   bg-purple-50" : " text-blue-500 bg-blue-50"}  font-light `}
            >
              {params.value}
            </div>
          );
        },
      },

      {
        field: "operator",
        headerName: "Opérateur",
        width: 100,

        renderCell: (params) => {
          const operator = params.value;

          for (const member of users) {
            if (member.display_name === operator) {
              return (
                <div
                  className="inline-flex h-5 items-center rounded-full px-2 py-1"
                  style={{
                    backgroundColor: intToHexColor(member.color),
                    color: isColorTooDark(intToHexColor(member.color))
                      ? "white"
                      : "black",
                  }}
                >
                  {member.display_name}
                </div>
              );
            }
          }
          return <div>{params.value || ""}</div>;
        },
      },
      {
        field: "assistant",
        headerName: "Assistant",
        width: 100,

        renderCell: (params) => {
          const assistant = params.value;

          for (const member of users) {
            if (member.display_name === assistant) {
              return (
                <div
                  className="inline-flex h-5 items-center rounded-full px-2 py-1"
                  style={{
                    backgroundColor: intToHexColor(member.color),
                    color: isColorTooDark(intToHexColor(member.color))
                      ? "white"
                      : "black",
                  }}
                >
                  {member.display_name}
                </div>
              );
            }
          }
          return <div>{params.value || ""}</div>;
        },
      },
      {
        field: "conductor",
        headerName: "Conducteur",
        width: 100,

        renderCell: (params) => {
          const conductor = params.value;

          for (const member of conductors) {
            if (member.display_name === conductor) {
              return (
                <div
                  className="inline-flex h-5 items-center rounded-full px-2 py-1"
                  style={{
                    backgroundColor: intToHexColor(member.color),
                    color: isColorTooDark(intToHexColor(member.color))
                      ? "white"
                      : "black",
                  }}
                >
                  {conductor}
                </div>
              );
            }
          }
          return <div>{params.value || ""}</div>;
        },
      },
      {
        field: "creation_date",
        headerName: "Creation",
        width: 85,
        renderCell: (params) => {
          // Customize color based on status value
          const date_int = params.value;

          const date = new Date(date_int);
          return (
            <div>
              {date.toLocaleString("fr-FR", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
              })}
            </div>
          );
        },
      },

      {
        field: "date",
        headerName: "RDV",
        width: 100,
        renderCell: (params) => {
          // Customize color based on status value
          const date_int = params.value;
          if (date_int === 700) {
            return (
              <div className="h-5">
                <div className="inline-flex items-center rounded-full h-full px-2 py-1 text-neutral-300">
                  à définir
                </div>
              </div>
            );
          }
          if (date_int === 600) {
            return (
              <div className="h-5">
                <div className="inline-flex items-center rounded-full h-full px-2 py-1 text-red-400 bg-red-100">
                  demandé
                </div>
              </div>
            );
          }
          if (date_int === 0 || date_int === null) {
            return <div className="h-5"></div>;
          }
          const date = new Date(date_int);
          return (
            <div>
              {date.toLocaleDateString("fr-FR", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              })}
            </div>
          );
        },
      },

      { field: "pack_name", headerName: "Prestation", width: 120 },
      {
        field: "state",
        headerName: "Status",
        width: 130,

        renderCell: (param) => {
          const label = param.value;
          // Customize color based on status value

          return (
            <div className="h-5">
              {label === "A venir" && (
                <div className="inline-flex items-center rounded-full h-full px-2 py-1 bg-neutral-100 ">
                  {label}
                </div>
              )}
              {label === "Réalisé" && (
                <div className="inline-flex items-center rounded-full h-full px-2 py-1 bg-blue-100 ">
                  {label}
                </div>
              )}
              {label === "Archivé" && (
                <div className="inline-flex items-center rounded-full h-full px-2 py-1 bg-green-100 ">
                  {label}
                </div>
              )}
              {label === "Supprimé" && (
                <div className="inline-flex items-center rounded-full h-full px-2 py-1 bg-red-100 ">
                  {label}
                </div>
              )}
            </div>
          );
        },
      },

      {
        field: "all_tags",
        headerName: "Tags",
        flex: 1,
        renderCell: (params) => {
          // Customize color based on status value
          const tags = params.value;
          const handleOpenTag = (e, index) => {
            e.stopPropagation();
            openTag(params.row.id, index);
          };

          if (tags) {
            const tags_me =
              tags.filter((tag) =>
                workspaceData
                  ? tag.org_id === orgData.id
                  : params.row.admins_id.map((a) => a.id).includes(tag.org_id)
                    ? true
                    : tag.org_id === orgData.id
              ) || null;
            if (tags_me) {
              return (
                <div className="h-full flex-wrap space-x-2">
                  {tags_me.map((tag, index) => {
                    return (
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          console.log("click tag");
                          handleOpenTag(e, index);
                        }}
                        key={index}
                        className={`
                          inline-flex h-5 items-center cursor-pointer rounded-full px-2 py-1 
                          hover:opacity-80 transition-opacity
                          hover:border-1 hover:border-black hover:bg-neutral-50
                          
                        `}
                        style={{
                          color: isColorTooDark(intToHexColor(tag.colorint))
                            ? "white"
                            : "black",
                          backgroundColor: intToHexColor(tag.colorint),
                        }}
                      >
                        {tag.nom}
                      </div>
                    );
                  })}
                  <div
                    onClick={(e) => handleOpenTag(e, tags_me.length)}
                    className="inline-flex h-5 items-center text-shadow_25 bg-neutral-50 hover:bg-neutral-300 hover:text-shadow_25 rounded-full px-2 py-1"
                  >
                    Ajouter
                  </div>
                </div>
              );
            }
          }

          // Empty case
          return (
            <div className="h-5">
              <div
                onClick={(e) => handleOpenTag(e, 0)}
                className="inline-flex items-center rounded-full h-full px-2 py-1 text-shadow_25 hover:bg-neutral-100 transition-colors"
              >
                Ajouter
              </div>
            </div>
          );
        },
        sortComparator: (v1, v2, params1, params2) => {
          const tag1 =
            params1.value.find((tag) => tag.org_id === orgData.id)?.nom || "z";
          const tag2 =
            params2.value.find((tag) => tag.org_id === orgData.id)?.nom || "z";
          return tag1.localeCompare(tag2); // Sorting alphabetically by the tag name
        },
      },

      {
        field: "actions",
        headerName: "Actions",
        width: 90,
        renderCell: (params) => {
          // Customize color based on status value

          const actions = params.value;
          if (actions === 99) {
          }

          if (actions === 0) {
            return (
              <div className="items-center flex text-shadow_25 gap-2 flex-row align-middle h-full">
                0 action
                <Icon1 icon_name="done2" size={18} fill="#6aebab"></Icon1>{" "}
              </div>
            );
          }

          return (
            <div className="h-5">
              <div
                className="inline-flex items-center rounded-full h-full px-2 py-1 text-white"
                style={{
                  backgroundColor: "rgba(255, 100, 100, 1)", // dynamically set the background color
                }}
              >
                {actions + (actions > 1 ? " actions" : " action")}
              </div>
            </div>
          );
        },
      },

      {
        field: "special_mention",
        headerName: "Mention",
        width: 100,
        renderCell: (params) => {
          // Customize color based on status value

          const actions = params.value;
          let step = params.row.audit_step || 0;
          if (params.row.folder_type === "audit") {
            return (
              <div
                className=" h-5 inline-flex items-center rounded-full  px-2 py-1 text-white bg-indigo-400"
                style={{
                  // make background color be a color as dark as the number of the step
                  backgroundColor: `rgba(70, 85, 255, ${(params.row.audit_step + 1) / 12})`, // Adjust opacity based on audit step
                  color: step === 0 ? "grey" : step < 3 ? "black" : "white", // Adjust text color based on background color
                }}
              >
                {audit_steps_titles[params.row.audit_step]}
              </div>
            );
          }

          if (actions == -5) {
            return (
              <div className=" h-5 inline-flex items-center rounded-full  px-2 py-1 text-white bg-indigo-400">
                conformité
              </div>
            );
          } else if (actions == -10) {
            return (
              <div className="h-5">
                <div className="inline-flex items-center rounded-full h-full px-2 py-1  text-white bg-green-300">
                  finalisé
                </div>
              </div>
            );
          } else if (actions == -15) {
            return (
              <div className="h-5">
                <div className="inline-flex  text-h3 h-5 items-center rounded-full px-2 py-1 text-white bg-amber-400">
                  revisite
                </div>
              </div>
            );
          } else if (actions == -16) {
            return (
              <div className="h-5">
                <div className="inline-flex  text-h3 h-5 items-center rounded-full px-2 py-1 text-white bg-orange-400">
                  paiement
                </div>
              </div>
            );
          } else if (actions == -17) {
            return (
              <div className="h-5 inline-flex ">
                <div className="flex flex-row gap-1 items-center">
                  <div className="inline-flex  text-h3 h-5 items-center rounded-full px-2 py-1 text-white bg-red-500">
                    bloqué
                  </div>
                  <Icon1 icon_name="forbidden" size={18} fill="#ea1115"></Icon1>
                </div>
              </div>
            );
          } else if (actions == -20) {
            return (
              <div className="h-5">
                <div className="inline-flex items-center rounded-full h-full px-2 py-1 text-white bg-red-400">
                  retard
                </div>
              </div>
            );
          }
        },
      },

      {
        field: "notifs",
        headerName: "Msg",
        width: 50,
        renderCell: (params) => {
          // Customize color based on status value

          if (params.value) {
            return (
              <div className="items-center align-middle h-full inline-flex">
                <Icon1 icon_name="message"></Icon1>
              </div>
            );
          } else {
            return <></>;
          }
        },
      },

      // Add more columns as needed
    ];

    // Create rows from the clients array
    let rows = folders.map((folder, index) => ({
      id: folder.id || index + 1, // Use client's ID or default index
      ref: folder.ref || null, // Include client's document reference
      num: folder.num || null, // Include client's document reference
      nom: folder.nom.trim() || "", // Use client's name or default 'Unknown'
      ville: folder.ville || "", // Use client's type or default
      entreprise_name:
        (folder.marque || folder.folder_entreprise_name || "") +
        " " +
        (all_workspaces.find(
          (workspace) => workspace.partner_id === folder.client_id
        )?.emoji || ""),
      operator: folder.operator_name || "", // Use client's type or default
      assistant: folder.assistant_name || "", // Use client's type or default
      conductor: folder.conductor_name || "", // Use client's type or default
      creation_date: folder.created_time.seconds * 1000 || 0,
      payment_allowed: folder.payment_allowed === true ? true : false, // Use client's type or default
      date: folder.dateintervention?.seconds
        ? folder.dateintervention?.seconds * 1000
        : folder.intervention_time_int
          ? folder.intervention_time_int * 1000
          : !folder.dateintervention?.seconds && folder.rdv_state === "wait"
            ? 600
            : !folder.dateintervention?.seconds && folder.rdv_state !== "wait"
              ? 700
              : null, // Use client's city or d

      pack_name: folder.pack_name || "", // Use client's city or default
      state: getStatus(
        folder.visions || [],
        folder.intervention_realisee || false,
        orgData
      ), // Use client's city or default
      // Use client's city or default
      all_tags: folder.tags.concat(folder.tags2 || []) || [],
      admins_id: folder.admins_id || [], // Use client's city or default
      tags: folder.tags || [],
      tags2: folder.tags2 || [],
      actions: folder.counters.find((counter) => counter.org_id == orgData.id)
        ? folder.counters.find((counter) => counter.org_id == orgData.id)
            .counter
        : 99,
      special_mention: folder.blocked
        ? -17
        : folder.conforme === false
          ? -5
          : folder.reglement_state == "done"
            ? -10
            : folder.reglement?.state == "wait"
              ? -16
              : folder.revisions?.length === 0
                ? -15
                : folder.late
                  ? -20
                  : null,
      notifs: folder.notified_orgs_id?.includes(orgData.id)
        ? true
        : false || false,
      client_type: folder.client_type || "constructor",

      structure_type: folder.structure_type || "",
      phone: folder?.reglement?.infos?.phone || "",
      first_name: folder?.reglement?.infos?.first_name || "",
      postal: folder?.postal || "",
      audit_step: folder?.timeline?.current_step || 0,
      folder_type: folder?.folder_type || "",
    }));

    rows = rows.sort((a, b) => {
      return (
        a.nom?.toLowerCase().trim() ||
        "".localeCompare(b.nom?.toLowerCase().trim() || "")
      );
    });

    return { rows, columns }; // Return rows and columns for the DataGrid
  } catch (e) {
    console.error(e);
    return { rows: [], columns: [] };
  }
}

export function transformInvoicesToTable(
  invoices,
  theme,
  tab = "waiting",
  searchvaue = "",
  handleSendAgain,
  orgData,
  searchInvoices = true
) {
  // Define columns for DataGrid, customize based on your data structure
  if (searchvaue !== "") {
    if (searchInvoices) {
      invoices = invoices.filter((invoice) =>
        (invoice.nom?.toLowerCase() + " - " + invoice.num).includes(
          searchvaue?.toLowerCase()
        )
      );
    } else {
      invoices = invoices.filter((invoice) =>
        invoice.marque.includes(searchvaue)
      );
    }
  } else {
    if (tab === "drafts") {
      invoices = invoices.filter((invoice) => invoice.state === "draft");
    }
    if (tab === "cancelled") {
      invoices = invoices.filter((invoice) => invoice.state === "cancelled");
    }
    if (tab === "waiting") {
      invoices = invoices.filter(
        (invoice) =>
          (invoice.state === "wait" || invoice.state === "locked") &&
          (!invoice.archived || invoice.archived === undefined) &&
          !invoice.folder_ref
      );
    }
    if (tab === "signed") {
      invoices = invoices.filter(
        (invoice) => invoice.state === "done" && !invoice.folder_ref
      );
    }
    if (tab === "archived") {
      invoices = invoices.filter((invoice) => invoice.archived);
    }
    if (tab === "with_folder") {
      invoices = invoices.filter((invoice) => invoice.folder_ref);
    }
  }
  // filter invoices by tag && state

  const columns = [
    { field: "id", headerName: "Id", flex: 1 },
    { field: "num", headerName: "Num", width: 100 },

    { field: "nom", headerName: "Nom", flex: 1 },
    {
      field: "marque",
      headerName: "Client",
      width: 140,
      renderCell: (params) => {
        console.log(params.value);
        let marque = params.value;
        // if marque is object use the label key
        if (typeof marque === "object" && marque.label) {
          marque = marque.label || "";
        }
        return (
          <div
            className={`inline-flex h-6 border items-center rounded-lg px-2 py-1 flex-row ${params.row.client_type === "constructor" ? "text-indigo-500 bg-indigo-50" : params.value === "Particulier" ? "text-purple-500 bg-purple-50" : "text-blue-500  bg-blue-50 "}  font-light `}
          >
            {marque}
          </div>
        );
      },
    },
    {
      field: "date",
      headerName: "Création",
      width: 110,
      type: "date",
    },
    {
      field: "last",
      headerName: "Dernier envoi",
      width: 140,
      renderCell: (params) => {
        let last = params.value;
        // Customize color based on status value

        return (
          <div
            className={`flex flex-col w-fit justify-center h-full ${last ? "text-shadow_75-400" : "text-red-400"}`}
          >
            {last && new Date(last).toLocaleString()}
          </div>
        );
      },
    },

    { field: "phone", headerName: "Téléphone", width: 110 },
    { field: "email", headerName: "Email", flex: 1 },
    {
      field: "author",
      headerName: "Origine",
      width: 120,
      renderCell: (params) => {
        let author = params.value;
        // Customize color based on status value

        return (
          <div className=" flex flex-col w-fit justify-center h-full">
            {author === "master" && (
              <div className=" flex-row px-2  flex h-6 rounded-full items-center bg-indigo-300 text-white">
                expert
              </div>
            )}
            {author === "client" && (
              <div className="flex-row px-2  flex h-6 rounded-full items-center bg-blue-300 text-white">
                client
              </div>
            )}

            {author === "website" && (
              <div className="flex-row px-2  flex h-6 rounded-full items-center bg-purple-300 text-white">
                site web
              </div>
            )}
          </div>
        );
      },
    },
    {
      field: "state",
      headerName: "Etat",
      width: 120,
      renderCell: (params) => {
        let state = params.value;
        // Customize color based on status value

        return (
          <div className=" flex flex-col w-fit justify-center h-full">
            {state === "draft" && (
              <div className=" flex-row px-2  flex h-6 rounded-full items-center bg-neutral-500 text-white">
                brouillon
              </div>
            )}
            {state === "locked" && !params.row.folder_id && (
              <div className=" flex-row px-2  flex h-6 rounded-full items-center bg-neutral-200 text-gray-400">
                pas envoyé
              </div>
            )}
            {state === "wait" && !params.row.folder_id && (
              <div className="flex-row px-2  flex h-6 rounded-full items-center bg-orange-300 text-white">
                en attente
              </div>
            )}

            {state === "done" && !params.row.folder_id && (
              <div className="flex-row px-2  flex h-6 rounded-full items-center bg-lime-300 text-white">
                signé
              </div>
            )}

            {params.row.folder_id && state !== "cancelled" && (
              <div className="flex-row px-2  flex h-6 rounded-full items-center bg-green-300 text-white">
                dossier
              </div>
            )}

            {state === "error" && (
              <div className="flex-row px-2  flex h-6 rounded-full items-center bg-red-300 text-white">
                erreur
              </div>
            )}

            {state === "cancelled" && (
              <div className="flex-row px-2  flex h-6 rounded-full items-center bg-red-300 text-white">
                annulé
              </div>
            )}
          </div>
        );
      },
    },

    // Add more columns as needed
  ];

  // Create rows from the clients array
  let rows = invoices.map((invoice, index) => ({
    id: invoice.id || index + 1, // Use client's ID or default index
    ref: invoice.ref || null, // Include client's document reference
    nom: invoice.nom || "", // Use client's name or default 'Unknown'
    num: invoice.num_devis || null, // Include client's document reference
    marque: invoice.marque || "", // Use client's type or default
    date: invoice.creation_date
      ? new Date(invoice.creation_date.seconds * 1000)
      : null, // Use client's city or default
    last: invoice.last_sent_seconds
      ? new Date(invoice.last_sent_seconds * 1000)
      : null, // Use client's city or default
    phone: invoice.tel_client || "", // Use client's name or default 'Unknown'

    email: invoice.email_client || "", // Use client's name or default 'Unknown'
    org_id: invoice.org_id || null, // Use client's name or default 'Unknown'
    state: invoice.state || "", // Use client's city or default
    client_type: invoice.client_type || "architect",
    author: invoice.author || "", // Use client's city or default
    folder_id: invoice.folder_ref?.id || null, // Use client's city or default
  }));

  rows = rows.sort((a, b) => {
    return a.nom.trim().localeCompare(b.nom.trim());
  });

  return { rows, columns }; // Return rows and columns for the DataGrid
}

export function transformEmailDeliveredToTable(
  emails,
  tab = "campaign",
  searchvaue = ""
) {
  // Define columns for DataGrid, customize based on your data structure
  if (searchvaue !== "") {
    emails = emails.filter((email) =>
      (email.subject?.toLowerCase() + " - " + email.to).includes(
        searchvaue?.toLowerCase()
      )
    );
  } else {
    if (tab === "campaign") {
      emails = emails.filter((email) => email.trigger_type === "campaign");
    }
    if (tab === "event") {
      emails = emails.filter((email) => email.trigger_type === "event");
    }
  }
  // filter emails by tag && state

  const columns = [
    { field: "id", headerName: "Id", flex: 1 },

    { field: "email_template_id", headerName: "email_template_id", flex: 1 },
    { field: "org_id", headerName: "org_id", flex: 1 },

    { field: "subject", headerName: "subject", flex: 1 },
    { field: "to", headerName: "to", flex: 1 },

    {
      field: "sent_at",
      headerName: "sent_at",
      width: 140,
      renderCell: (params) => {
        let last = params.value;
        // Customize color based on status value

        return (
          <div
            className={`flex flex-col w-fit justify-center h-full ${last ? "text-shadow_75-400" : "text-red-400"}`}
          >
            {last && new Date(last).toLocaleString()}
          </div>
        );
      },
    },

    {
      field: "state",
      headerName: "state",
      width: 120,
      renderCell: (params) => {
        let state = params.value;
        // Customize color based on status value

        return (
          <div className=" flex flex-col w-fit justify-center h-full">
            {state === "sent" && (
              <div className=" flex-row px-2  flex h-6 rounded-full items-center bg-indigo-300 text-white">
                envoyé
              </div>
            )}
            {state === "clicked" && (
              <div className="flex-row px-2  flex h-6 rounded-full items-center bg-green-300 text-white">
                cliqué
              </div>
            )}
          </div>
        );
      },
    },

    // Add more columns as needed
  ];

  // Create rows from the clients array
  let rows = emails.map((email, index) => ({
    id: email.id || index + 1, // Use client's ID or default index
    ref: email.ref || null, // Include client's document reference
    subject: email.subject || "", // Use client's name or default 'Unknown'
    to: email.to || "", // Use client's name or default 'Unknown'
    email_template_id: email.email_template_id || "", // Use client's name or default 'Unknown'
    org_id: email.org_id || "", // Use client's name or default 'Unknown'
    sent_at: email.sent_at ? new Date(email.sent_at.seconds * 1000) : null, // Use client's city or default
    state: email.state || "", // Use client's city or default
    trigger_type: email.trigger_type || "", // Use client's city or default
  }));

  rows = rows.sort((a, b) => {
    return a.subject.trim().localeCompare(b.subject.trim());
  });

  return { rows, columns }; // Return rows and columns for the DataGrid
}
